module.exports = __webpack_public_path__ + "static/media/humza icons-09.540eb1c5.svg";